import type { FormProps } from "antd";
import { Button, Form, Input, Row, Select } from "antd";
import toast from "react-hot-toast";
import { AppDispatch, RootState } from "../../store/store";
import { useDispatch } from "react-redux";
import { addUser } from "../../store/slices/userSlice";
import { useSelector } from "react-redux";
import EditPhoneNumber from "../EditUserForm/EditPhoneInput";

type FieldType = {
  nom?: string;
  prenom?: string;
  email?: string;
  telephone?: string;
  password?: string;
  role?: string;
  // role
};

interface Props {
  onClose: () => void;
}

function AjouterUserForm({ onClose }: Props) {
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.user);

  const onFinish: FormProps<FieldType>["onFinish"] = async (values) => {
    console.log("Success:", values);
    dispatch(addUser(values))
      .unwrap()
      .then(() => {
        form.resetFields();
        toast.success("Utilisateur ajouté avec succés");
        onClose();
      })
      .catch((error: any) => {
        console.error("Error adding user:", error);
        toast.error("Une erreur est survenue");
      });
  };

  const onFinishFailed: FormProps<FieldType>["onFinishFailed"] = (
    errorInfo
  ) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      form={form}
      name="add_user"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      layout="vertical"
    >
      <Form.Item<FieldType>
        label="Nom"
        name="nom"
        rules={[{ required: true, message: "Veuillez saisir un nom!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item<FieldType>
        label="Prénom"
        name="prenom"
        rules={[{ required: true, message: "Veuillez saisir un prénom!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item<FieldType>
        label="Email"
        name="email"
        rules={[
          {
            required: true,
            message: "Veuillez saisir un email!",
            type: "email",
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item<FieldType>
        label="Mot de passe"
        name="password"
        rules={[
          { required: true, message: "Veuillez saisir un mot de passe!" },
        ]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
        name="telephone"
        label="Telephone"
        rules={[
          {
            required: true,
            message: "Veuillez saisir un numéro de téléphone !",
          },
        ]}
      >
        <EditPhoneNumber />
      </Form.Item>

      <Form.Item<FieldType>
        label="Role"
        name="role"
        rules={[{ required: true, message: "Veuillez saisir un role!" }]}
      >
        <Select
          options={[
            { value: "visiteur", label: "visiteur" },
            { value: "controleur", label: "controleur" },
            { value: "admin", label: "admin" },
          ]}
        />
      </Form.Item>
      <Row justify={"end"} style={{ width: "100%" }}>
        <Button
          variant="solid"
          onClick={onClose}
          color="danger"
          style={{ marginRight: "10px" }}
        >
          Annuler
        </Button>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Ajouter
          </Button>
        </Form.Item>
      </Row>
    </Form>
  );
}

export default AjouterUserForm;
